"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _BaseReporter2 = _interopRequireDefault(require("./BaseReporter"));

var _ReporterActionTypes = _interopRequireDefault(require("./ReporterActionTypes"));

var UnexpectedRouteReporter = /*#__PURE__*/function (_BaseReporter) {
  (0, _inherits2.default)(UnexpectedRouteReporter, _BaseReporter);

  function UnexpectedRouteReporter() {
    var _this;

    (0, _classCallCheck2.default)(this, UnexpectedRouteReporter);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UnexpectedRouteReporter).call(this));
    _this.resolved = {}; // eslint-disable-next-line no-restricted-globals

    _this.notifiedRoutes = new Set();
    return _this;
  }

  (0, _createClass2.default)(UnexpectedRouteReporter, [{
    key: "report",
    value: function report(action) {
      if (this.resolved[action.payload.entry.id] && action.type !== _ReporterActionTypes.default.CHECKS_CHANGED) {
        return;
      }

      var pathname = action.payload.entry.pathname;

      if (action.type === _ReporterActionTypes.default.ROUTE_UNEXPECTED) {
        if (!this.notifiedRoutes.has(pathname)) {
          this.addPageAction('react-rhumb-event', {
            eventName: 'UnexpectedRouteVisited',
            pathname: pathname
          });
          this.notifiedRoutes.add(pathname);
        }

        this.resolved[action.payload.entry.id] = true;
      }
    }
  }]);
  return UnexpectedRouteReporter;
}(_BaseReporter2.default);

exports.default = UnexpectedRouteReporter;
module.exports = exports.default;